import * as React from "react";

import type { AppTabListProps, AppTabListState } from "./AppTabList.types";
import type { SelectTabEventHandler } from "@fluentui/react-components";
import { useTabList_unstable } from "@fluentui/react-components";

import { useTabs } from "./useTabs";

/**
 * Given user props, returns state for a `Pivot`.
 */
export const useAppTabList = (
  props: AppTabListProps,
  ref: React.Ref<HTMLElement>
): AppTabListState => {
  const { "aria-label": ariaLabel, size = "small" } = props;

  const { automationType, label, onTabHeaderClick, selectedTabId, children } =
    props;

  const onTabSelect: SelectTabEventHandler = React.useCallback(
    (_event, data) => {
      onTabHeaderClick(data.value as string);
    },
    [onTabHeaderClick]
  );

  const dataProps = {
    "data-automation-type": automationType,
  };

  const defaultTabs = useTabs(props);

  const tabListState = useTabList_unstable(
    {
      ...props,
      ...dataProps,
      selectedValue: selectedTabId,
      size,
      "aria-label": ariaLabel ?? label,
      children: children || defaultTabs,
      onTabSelect,
    },
    ref
  );

  return {
    ...props,
    ...tabListState,
  } as AppTabListState;
};
